<template>
    <div>
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div class="partnerial-head">
            <div class="container">
                <div class="content-header content-box">
                    <div class="row">
                        <div class="col">
                            <div class="content-header">
                                <h1 class="content-title content-title_partnerial">{{$t('meta.partners.h1')}}</h1>
                                <span class="team-headline-text team-headline-text_partnerial">{{$t('public.partners.main_description')}}</span>
                            </div>
                            <div class="partnerial-item">
                                <h4 class="partnerial-item-title">{{$t('public.partners.eccomerce_platforms')}}</h4>
                                <ul class="partnerial-item-nav flex-wrap">
                                    <li><a href="#"><img src="~img/partners1.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li><a href="#"><img src="~img/partners6.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li><a href="#"><img src="~img/partners12.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li><a href="#"><img src="~img/partners3.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li><a href="#"><img src="~img/partners11.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li><a href="#"><img src="~img/partners5.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li><a href="#"><img src="~img/partners13.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                </ul>
                            </div>
                            <div class="partnerial-item" v-if="false">
                                <h4 class="partnerial-item-title">{{$t('public.partners.sendparcel_partners')}}</h4>
                                <ul class="partnerial-item-nav mb-3 flex-wrap">
                                    <li class="mb-3"><a href="#"><img src="~img/partners10.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners18.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners14.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners16.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                </ul>
                                <ul class="partnerial-item-nav flex-wrap">
                                    <li class="mb-3"><a href="#"><img src="~img/partners15.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners7.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners17.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners19.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners20.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners21.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                </ul>
                            </div>
                            <div class="partnerial-item">
                                <h4 class="partnerial-item-title">{{$t('public.partners.sendparcel_partners')}}</h4>
                                <ul class="partnerial-item-nav mb-3 flex-wrap">
                                    <li class="mb-3">
                                        <a href="#"><img src="~img/partners7.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')" style="max-width: 100px"></a>
                                    </li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners19.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners16.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners14.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners15.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners10.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                </ul>
                                <ul class="partnerial-item-nav flex-wrap">
                                    <li class="mb-3">
                                        <a href="#"><img src="~img/partners18.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')" style="max-width: 80px"></a>
                                    </li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners17.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                    <li class="mb-3"><a href="#"><img src="~img/partners20.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <main class="main-box partnerial-head">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8 mb-5">
                        <div v-html="$t('public.partners.main_info')"></div>
                    </div>
                </div>
            </div>
        </main><!-- End Main -->

        <div class="full">
            <div class="full-background"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-md-5">
                                <div class="full-info">
                                    <div>
                                        <h4 class="full-info-title">{{$t('public.partners.block.title')}}</h4>
                                        <span class="full-info-text">{{$t('public.partners.block.text')}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="full-img" :class="$i18n.locale === 'lt' ? 'img-lt' : 'img-en'">
                <img v-if="$i18n.locale === 'lt'" src="~img/partners-lt.jpg" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')">
                <img v-else src="~img/partners-en.jpg" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')">
            </div>
        </div>
        <footer-component></footer-component>
    </div>

</template>

<script>
    export default {
        name: 'Partnerial',
        metaInfo() {
            return {
                title: this.$t('meta.partners.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.partners.description') },
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Public/Partnerial.vue